export default __webpack_public_path__ + "static/media/hbs-k-cbb-poster-3.7bc1c7c9.jpg";